<template>
    <table class="mt-m">
        <tr>
            <th scope="row">Access key</th>
            <td>{{ access_key }}
                <button @click="copyText(access_key)" class="unstyled-button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="16" width="16" fill="#051C2E"><path d="M5.125 17.417q-.563 0-.948-.386-.385-.385-.385-.948V5.667h1.083v10.416q0 .105.073.177.073.073.177.073h8.417v1.084Zm2.583-2.584q-.562 0-.948-.385-.385-.386-.385-.948V4.021q0-.563.385-.958.386-.396.948-.396h7.48q.562 0 .958.396.396.395.396.958V13.5q0 .562-.396.948-.396.385-.958.385Zm0-1.083h7.48q.104 0 .187-.073t.083-.177V4.021q0-.104-.083-.188-.083-.083-.187-.083h-7.48q-.104 0-.177.083-.073.084-.073.188V13.5q0 .104.073.177t.177.073Zm-.25 0v-10 10Z"/></svg>
                </button>
            </td>
        </tr>
        <tr>
            <th scope="row">Secret key</th>
            <td><span class="xs-font">{{ secret_key }}</span>
                <button @click="copyText(secret_key)" class="unstyled-button">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" height="16" width="16" fill="#051C2E"><path d="M5.125 17.417q-.563 0-.948-.386-.385-.385-.385-.948V5.667h1.083v10.416q0 .105.073.177.073.073.177.073h8.417v1.084Zm2.583-2.584q-.562 0-.948-.385-.385-.386-.385-.948V4.021q0-.563.385-.958.386-.396.948-.396h7.48q.562 0 .958.396.396.395.396.958V13.5q0 .562-.396.948-.396.385-.958.385Zm0-1.083h7.48q.104 0 .187-.073t.083-.177V4.021q0-.104-.083-.188-.083-.083-.187-.083h-7.48q-.104 0-.177.083-.073.084-.073.188V13.5q0 .104.073.177t.177.073Zm-.25 0v-10 10Z"/></svg>
                </button>
            </td>
        </tr>
        <tr>
            <th scope="row">Key&nbsp;description</th>
            <td>{{key_desc}}</td>
        </tr>
        <tr>
            <th scope="row">Project&nbsp;number</th>
            <td>{{prjnum}}</td>
        </tr>
        <tr>
            <th scope="row">Project&nbsp;description</th>
            <td>{{prj_desc}}</td>
        </tr>
        <tr>
            <th scope="row">Key owner</th>
            <td>{{key_owner}}</td>
        </tr>
        <tr>
            <th scope="row">Creation time</th>
            <td>{{creation_time}}</td>
        </tr>
        <tr>
            <th scope="row">Expires on</th>
            <td>{{expiry_time}}</td>
        </tr>
    </table>
</template>

<script>

export default {
    name: 'KeyDetails',
    emits: ['key-copied'],
    props: {
        access_key: String,
        secret_key: String,
        key_desc: String,
        prjnum: String,
        prj_desc: String,
        key_owner: String,
        created: Number,
        expire: Number
    },
    methods: {
        copyText(str) {
            this.emitter.emit('key-copied');
            navigator.clipboard.writeText(str);
        },
        convertDate(t) { // epoch
            let date = new Date(t*1000).toString();
            date = date.slice(3); //remove day of week: always 4 chars at the start
            return date.split(' (')[0]; //remove timezone name: variable length, in brackets
        }
    },
    computed: {
        creation_time() {
            return this.convertDate(this.created);
        },
        expiry_time() {
            return this.convertDate(this.expire);
        }
    }
}

</script>

<style scoped>

th {
  font-size: 0.9rem; /*14.4*/
  line-height: 1.5;
  text-align: left;
}

td {
  font-size: 0.8rem; /*13*/
  line-height: 1.5;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  overflow-wrap: anywhere; /**secret key will break into two lines */
  border-bottom: 1px solid var(--blue-gray);
}

.xs-font {
    font-size: 0.75rem;
}

button  {
    padding: 0;
}

@media screen and (max-width: 500px) {
    tr {
        display: flex;
        flex-direction: column;
    }

    td {
        padding-top: 0;
    }

    th {
        padding-bottom: 0.3rem;
    }
}
</style>